/**
 * @param {string} host
 * @param {string} namespace
 * @returns {string}
 */
const montarFarolDoDPSupersetUrl = (host, namespace) => {
  if (host.startsWith('hml')) {
      return 'https://analytics-hastati.pontotel.com.br'
  }
    return `https://superset-${namespace}.pontotel.com.br`
}

/**
 * @param {string} url
 * @param {string} namespace
 * @returns {string}
 */
const montarUrlFarolDoDP2 = (url, namespace) => {
  return url.replace('/pontotel/', `/${namespace}/`)
}

/** @returns {string} */
const descobrirNamespace = () => {
  let namespace = window.location.pathname
  namespace = namespace[namespace.length - 1] === '/' ? namespace.slice(0, namespace.length - 1) : namespace
  namespace = namespace.split('/new-front')[0]

  return namespace
}

/**
 * @description Montar a url do keycloak para K8S baseado no namespace para cada alpha
 * a url sempre será https://kc-<namespace>.pontotel.com.br
 * com exceção de homolog, que será https://keycloak.pontotel.com.br
 * @param {string} namespace
 * @returns {string}
 */
const montarUrlKeycloakK8s = (namespace) => {
  const url = process.env.VUE_APP_KEYCLOAK_BASE_URL

  // se for homolog
  if (namespace === 'pontotel') {
    return url
  }

  const urlNoAlpha = url.replace('keycloak-homolog', `kc-${namespace}`)
  return urlNoAlpha
}

/**
 * @param {string} namespace
 * @returns {string}
 */
const montarUrlAloqueK8s = (namespace) => {
  return resolverUrlBaseAloqueK8s(
    process.env.VUE_APP_ALOQUE_FRONTEND_URL,
    namespace
  )
}

import { obterSecret } from 'src/typescript/servicos/bifrost/bifrost.servico'
import { resolverUrlBaseAloqueK8s } from 'src/typescript/modulos/calendario-de-trabalho/CalendarioAloque/dominio/urlCalendarioAloque'

// Token de acesso ao tio sam - obtido via Bifrost
const tioSamEndPoint = process.env.VUE_APP_TIOSAM_URL

let baseUrl
let gerenciadorDeColetoresUrl
let reppUrl
let integracaoUrl
let auditorUrl
let auditorGestaoUrl
let integradorSankhyaUrl
let farolDoDPSupersetUrl
let farolDoDP2Url
let agentePttUrl
let controleDeEstacoesUrl
let keycloakBaseUrl
let baseFastApiUrl
let aloqueFrontendUrl
let mcpUrl
const recaptchaToken = process.env.VUE_APP_RECAPTCHA_PUBLIC_TOKEN

if (process.env.VUE_APP_K8s) {

  const namespace = descobrirNamespace();

  baseUrl = `${window.location.origin}${namespace}` + '/back'
  gerenciadorDeColetoresUrl = `${window.location.origin}${namespace}` + '/gerenciador-de-coletores'
  reppUrl = `${window.location.origin}${namespace}` + '/rep-p'
  integracaoUrl = `${process.env.VUE_APP_INTEGRACAO_URL}`
  auditorUrl = `${window.location.origin}${namespace}` + '/auditor-log'
  farolDoDPSupersetUrl = montarFarolDoDPSupersetUrl(window.location.host, namespace.slice(1))
  farolDoDP2Url = montarUrlFarolDoDP2(process.env.VUE_APP_FAROL_DO_DP_2_URL, namespace.slice(1))
  agentePttUrl = `${window.location.origin}${namespace}` + '/agente-ptt'
  controleDeEstacoesUrl = `${window.location.origin}${namespace}` + '/controle-de-estacoes'
  integradorSankhyaUrl = `${window.location.origin}${namespace}` + '/integrador-sankhya'
  auditorGestaoUrl = `${window.location.origin}${namespace}` + '/auditor-gestao/htmx/auditoria/agrupadas'
  keycloakBaseUrl = montarUrlKeycloakK8s(namespace.slice(1))
  baseFastApiUrl = `${window.location.origin}${namespace}` + '/back-fastapi'
  aloqueFrontendUrl = montarUrlAloqueK8s(namespace.slice(1))
  // Servidor MCP que o cliente de fora (tela /conexoes-mcp) alcança. Ainda não
  // há instância exposta; ver docs/COMO_EXPOR_PARA_CLIENTE_EXTERNO.md no
  // servidor MCP do condominio.
  mcpUrl = process.env.VUE_APP_MCP_URL
} else {
  baseUrl = `${process.env.VUE_APP_API_URL}`
  integracaoUrl = `${process.env.VUE_APP_INTEGRACAO_URL}`
  gerenciadorDeColetoresUrl = `${process.env.VUE_APP_GERENCIADOR_DE_COLETOR_URL}`
  reppUrl = `${process.env.VUE_APP_REPP_URL}`
  auditorUrl = `${process.env.VUE_APP_AUDITOR_URL}`
  farolDoDPSupersetUrl = `${process.env.VUE_APP_FAROL_DO_DP_URL}`
  farolDoDP2Url = `${process.env.VUE_APP_FAROL_DO_DP_2_URL}`
  agentePttUrl = `${process.env.VUE_APP_AGENTE_PTT_URL}`
  controleDeEstacoesUrl = `${process.env.VUE_APP_CONTROLE_DE_ESTACOES_URL}`
  integradorSankhyaUrl = `${process.env.VUE_APP_INTEGRADOR_SANKHYA_URL}`
  auditorGestaoUrl = `${process.env.VUE_APP_AUDITOR_GESTAO_URL}` + '/htmx/auditoria/agrupadas'
  keycloakBaseUrl = `${process.env.VUE_APP_KEYCLOAK_BASE_URL}`
  baseFastApiUrl = `${process.env.VUE_APP_BACK_FASTAPI_API_URL}`
  aloqueFrontendUrl = `${process.env.VUE_APP_ALOQUE_FRONTEND_URL || ''}`
  mcpUrl = process.env.VUE_APP_MCP_URL
}

const config = {
  baseUrl,
  integracaoUrl,
  auditorUrl,
  farolDoDPSupersetUrl,
  farolDoDP2Url,
  auditorGestaoUrl,
  integradorSankhyaUrl,
  agentePttUrl,
  controleDeEstacoesUrl,
  gerenciadorDeColetoresUrl,
  reppUrl,
  version: '5.0.0',
  keycloakBaseUrl,
  recaptchaToken,
  get tioSamAccessToken () { return obterSecret('TIOSAM_ACCESS_TOKEN') },
  tioSamEndPoint,
  baseFastApiUrl,
  aloqueFrontendUrl,
  // Getter: o padrão lê `window`, que não existe quando os testes em Node
  // importam este módulo.
  get mcpUrl () { return mcpUrl || `${window.location.origin}/mcp` },
  // Sem VUE_APP_MCP_URL não há servidor MCP exposto neste ambiente: a tela
  // /conexoes-mcp emite a delegação, mas avisa que o cliente externo ainda não
  // tem onde se conectar.
  mcpExpostoNoAmbiente: Boolean(mcpUrl)
}

export default config
